// extracted by mini-css-extract-plugin
module.exports = {"otherProduct":"otherProduct_otherProduct__K1rbq"};